import ModalApplyPayment from './ModalApplyPayment';

export default ModalApplyPayment;
